import {AuthMutations, AuthQueries} from '../../api/auth'
import {
  // addLeadRequestAction, //DEPRECATED
  basicActions,
  checkEmailRequestAction,
  phoneLoginLinkEmailAction,
  phoneLoginResetAction,
  phoneLoginSendOtpAction,
  phoneLoginVerifyOtpAction,
  recoverPasswordRequestAction,
  removeAccountRequestAction,
  signInRequestAction,
  signOutRequestAction,
  signUpRequestAction,
} from './actions'
import {basicSelectors} from './selectors'

export const AuthService = {
  actions: {
    ...basicActions,
    checkEmailRequestAction,
    signUpRequestAction,
    signInRequestAction,
    signOutRequestAction,
    removeAccountRequestAction,
    recoverPasswordRequestAction,
    phoneLoginSendOtpAction,
    phoneLoginVerifyOtpAction,
    phoneLoginLinkEmailAction,
    phoneLoginResetAction,
  },
  selectors: {...basicSelectors},
  queries: AuthQueries,
  mutations: AuthMutations,
} as const
